import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { ga } from '@/lib/analytics';

const getCustomTitle = (path: string) => {
  if (path === '/') return 'Home';

  const cleanTitle = path
    .split('/')
    .filter(Boolean)
    .map(
      (word) =>
        word.charAt(0).toUpperCase() +
        word.slice(1).replace(/-/g, ' '),
    )
    .join(' ');

  return cleanTitle || 'Default Title';
};

export const usePageTitle = () => {
  const location = useLocation();

  return getCustomTitle(location.pathname);
};

const GALocationTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const customTitle = getCustomTitle(location.pathname);

    // `page` is a stable token (games, compliance, game_detail) that every
    // subsequent event inherits, so call sites don't repeat it. Events
    // fired outside a route — the global search modal — override it.
    ga.setParams({
      page_title: customTitle,
      page: ga.pageName(location.pathname),
    });
    ga.trackPageView({
      page_title: customTitle,
      page_location: window.location.href,
      page_path: location.pathname,
    });
  }, [location]);

  return null;
};

export default GALocationTracker;
